import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

/**
 * Secure logout utility that clears all sensitive data from browser storage
 * Addresses STORAGE_EXPOSURE security finding
 */
export const secureLogout = async (): Promise<void> => {
  try {
    // Sign out from Supabase
    await supabase.auth.signOut();
    
    // Clear all localStorage data
    localStorage.clear();
    
    // Clear all sessionStorage data
    sessionStorage.clear();
    
    logger.info('[Auth] Secure logout completed');
  } catch (error) {
    logger.error('[Auth] Logout error', error);
    // Still clear storage even if signOut fails
    localStorage.clear();
    sessionStorage.clear();
    throw new Error('Logout failed');
  }
};
